var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-xs-right"},[_c('v-chip',{class:_vm.chipClass(),attrs:{"small":"","text-color":"white"}},[_vm._v("\n    "+_vm._s(_vm.$t(`status.${_vm.value}`))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }